export const CopyEmailToClipBoard = (email: string) => {
  navigator.clipboard.writeText(email);
  alert('E-mail скопирован в буфер обмена');
}